import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { gsap } from 'gsap';
import panel1 from '../asserts/panel1.png';
import panel2 from '../asserts/panel2.png';
import panel3 from '../asserts/panel3.png';
import panel4 from '../asserts/panel4.png';
import panel5 from '../asserts/panel5.png';
import panel6 from '../asserts/panel6.png';
import narration from '../asserts/narration.mp3';
import { useMusic } from '../components/layout/MusicContext';
import Btn4 from '../components/common/Btn4';
import './story.css';

const panels = [
  { img: panel1, delay: 0 },
  { img: panel2, delay: 5000 },
  { img: panel3, delay: 10000 },
  { img: panel4, delay: 13000 },
  { img: panel5, delay: 20000 },
  { img: panel6, delay: 29000 },
];

const StoryIntro = () => {
  const navigate = useNavigate();
  const panelRefs = useRef([]);
  const narrationRef = useRef(null);
  const timersRef = useRef([]);
  const { muteBgMusic, unmuteBgMusic } = useMusic();

  useEffect(() => {
    muteBgMusic();

    panelRefs.current.forEach((panel) => {
      gsap.set(panel, { y: 200, opacity: 0 });
    });

    narrationRef.current = new Audio(narration);
    narrationRef.current.volume = 1.0;
    narrationRef.current.play().catch(() => {});

    panels.forEach((p, i) => {
      const timer = setTimeout(() => {
        const el = panelRefs.current[i];
        if (!el) return;
        gsap.to(el, { y: 0, opacity: 1, duration: 1.4, ease: 'power3.out' });
      }, p.delay + i * 1000);
      timersRef.current.push(timer);
    });

    const navTimer = setTimeout(() => navigate('/mainmenu'), 50000);
    timersRef.current.push(navTimer);

    return () => {
      unmuteBgMusic();
      timersRef.current.forEach(clearTimeout);
      if (narrationRef.current) {
        narrationRef.current.pause();
        narrationRef.current = null;
      }
    };
  }, [navigate]);

  const handleSkip = () => {
    timersRef.current.forEach(clearTimeout);
    if (narrationRef.current) {
      narrationRef.current.pause();
      narrationRef.current = null;
    }
    unmuteBgMusic();
    navigate('/mainmenu');
  };

  return (
    <div className="story-container">
      <div className="story-skip">
        <Btn4 label="Skip" onClick={handleSkip} />
      </div>
      <div className="story-panels">
        {panels.map((p, i) => (
          <div
            key={i}
            className="story-panel"
            ref={(el) => (panelRefs.current[i] = el)}
          >
            <img src={p.img} alt={`panel ${i + 1}`} className="panel-image" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default StoryIntro;